module.exports = __webpack_public_path__ + "img/midday-background.86203667.png";